import React, { useRef, useState } from "react";
import { Tooltip } from "@mui/joy";

type HeaderCellProps = Omit<
  React.ThHTMLAttributes<HTMLTableCellElement>,
  "children"
> & { children: string };

// A table header cell for Joy's <Table>, which cuts long headings short with an
// ellipsis. When it has, hovering shows the full heading; otherwise nothing.
export const HeaderCell: React.FC<HeaderCellProps> = ({
  children,
  ...props
}) => {
  const ref = useRef<HTMLTableCellElement>(null);
  const [open, setOpen] = useState(false);

  return (
    <Tooltip
      title={children}
      open={open}
      // Measured on hover, so it keeps up with resizes and columns coming and going.
      onOpen={() => {
        const cell = ref.current;
        setOpen(!!cell && cell.scrollWidth > cell.clientWidth);
      }}
      onClose={() => setOpen(false)}
      size="sm"
    >
      <th ref={ref} {...props}>
        {children}
      </th>
    </Tooltip>
  );
};
